import React, { useMemo, useState } from "react";
import Chart from "react-apexcharts";

const FORECAST_TYPES = [
  { key: "linearForecast", label: "Linear Forecast" },
  { key: "smaForecast", label: "SMA Forecast" },
  { key: "growthForecast", label: "Growth Forecast" },
  { key: "momForecast", label: "MoM Forecast" },
  { key: "overallGrowthForecast", label: "Overall Growth" },
];

const ForecastChart = ({ forecastData }) => {
  const [type, setType] = useState("linearForecast");

  const selectedData = useMemo(() => {
    return forecastData?.forecasts?.[type] || [];
  }, [forecastData, type]);

  if (!forecastData?.forecasts) return null;


  const series = [
    {
      name: "Forecast Income",
      data: selectedData.map((d) => Number(d.forecastIncome.toFixed(2))),
    },
    {
      name: "Forecast Expense",
      data: selectedData.map((d) => Number(d.forecastExpense.toFixed(2))),
    },
  ];

  const options = {
    chart: { toolbar: { show: false } },
    colors: ["#10B981", "#EF4444"],
    plotOptions: {
      bar: { borderRadius: 6, columnWidth: "45%" },
    },
    dataLabels: { enabled: false },
    xaxis: { categories: selectedData.map((d) => d.month) },
    legend: { position: "top" },
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-2">
        <p className="text-sm font-bold text-gray-600 uppercase">
          Forecast Profit & Loss
        </p>

      </div>

      {/* Forecast Type Tabs */}
      <div className="flex flex-wrap gap-2 mb-2">
        {FORECAST_TYPES.map((t) => (
          <button
            key={t.key}
            onClick={() => setType(t.key)}
            className={`px-3 py-1 text-xs rounded-lg font-semibold transition
              ${
                type === t.key
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Chart */}
      {selectedData.length === 0 ? (
        <div className="p-10 text-center text-gray-400 border border-dashed rounded-xl">
          No forecast data available
        </div>
      ) : (
        <Chart options={options} series={series} type="bar" height={350} />
      )}
    </div>
  );
};

export default ForecastChart;
